import { useIsProtected } from '@/state/store/auth/use-is-protected';

/**
 * Whether the signed-in user holds a permission from `HRM_PERMISSIONS`.
 * Pass several to match any of them, or `opt: 'all'` to require every one.
 */
export const useHasPermission = (permission: string | string[], opt: 'all' | 'any' = 'any') => {
  const permissions = Array.isArray(permission) ? permission : [permission];
  return useIsProtected({ permissions, opt }).isProtected;
};
